"use strict";

const images = document.querySelectorAll('img');

images.forEach((element) => {
    if (
        element.classList.contains('is-logo') &&
        element.parentElement.parentElement.parentElement.classList.contains('dynamic')
    ) {
        element.parentElement.parentElement.classList.add('white');
    }
});
